import styled from 'styled-components'

import { space, SpaceProps, spacing } from '../../../../themes'

export const Container = styled.div<SpaceProps>`
  ${space};
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${spacing(1)};
`
